import { configOption, KahunConfigurationOptionType } from "../lib/annotations";
import { MessageTemplate } from "./messageTemplate";

export class WhatsappOptions {
  @configOption({
    description: "Is this option enabled from the ui",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  enabled: boolean = true;

  @configOption({
    description: "Bearer token used to indentify the user",
    displayType: KahunConfigurationOptionType.String,
  })
  authenticationToken: string;
  @configOption({
    description:
      "Phone number id (not to be mixed with phone number!) as configured as 'Phone number ID' under https://developers.facebook.com/apps/{appId}/whatsapp-business/wa-dev-console/",
  })
  phoneNumberId: string;
  @configOption({
    description:
      "Message templates are configured per message touch point and language, multiple templates can be configured per touch point each for every language",
    displayType: KahunConfigurationOptionType.MessageTemplate,
  })
  messageTemplates: MessageTemplate[];
  @configOption({
    description:
      "Use this verify token when setting up webhooks for whatsapp messages. To use whatsapp webhook configure it to land under:" +
      "https://comm.kahun.com/whatsapp/{clinicId}/webhook" +
      "set up the token and url here: https://developers.facebook.com/apps/{{APP_ID}}/webhooks/?business_id=610805387450566",
  })
  whatsappWebHookToken: string;
}
